import styled from 'styled-components'

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 44px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding-top: 28px;
  }
`

export const UsersTableCard = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(210px, 250px) minmax(280px, 350px) auto;
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 12px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 32px;
  padding: 20px 12px 12px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  > .companies-toolbar {
    grid-column: 3;
    grid-row: 1;
    width: 100%;
  }

  > .users-management-table {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  @media (max-width: 1260px) {
    grid-template-columns: minmax(0, 1fr) auto;

    > .companies-toolbar {
      grid-column: 1 / -1;
      grid-row: 3;
    }

    > .users-management-table {
      grid-row: 4;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 18px 10px 10px;

    > .companies-toolbar,
    > .users-management-table {
      grid-column: 1;
    }

    > .companies-toolbar {
      grid-row: 4;
    }

    > .users-management-table {
      grid-row: 5;
    }
  }
`

export const UsersTableHeader = styled.div`
  display: contents;

  > button {
    grid-column: 4;
    grid-row: 1;
    margin: 0;
    white-space: nowrap;
  }

  @media (max-width: 1260px) {
    > button {
      grid-column: 2;
    }
  }

  @media (max-width: 768px) {
    > button {
      grid-column: 1;
      grid-row: 2;
      justify-self: stretch;
    }
  }
`

export const PageTitle = styled.h2`
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.15;
`

export const UserTypeContainer = styled.div`
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  gap: 10px;
  margin: 0;
  padding: 0;

  > div {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 1260px) {
    grid-column: 1;
    grid-row: 2;
    max-width: 360px;
  }

  @media (max-width: 768px) {
    grid-column: 1;
    grid-row: 3;
    max-width: none;
  }
`

export const FilterLabel = styled.p`
  flex: 0 0 auto;
  margin: 0;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
`

export const GridDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: none;
  cursor: pointer;
  gap: 5px;
`
export const AddIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: #2d749c;
  fill: #2d749c;
`
export const AddText = styled.p`
  font-family: 'Public Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #2d749c;
`
export const SaveButton = styled.button`
  justify-content: center;
  padding: 11px 22px;
  gap: 10px;
  width: 146px;
  height: 48px;
  background: #c2c2c2;
  box-shadow: 0px 8px 16px rgba(112, 112, 112, 0.24);
  border-radius: 8px;
  border: none;
  color: white;
  font-weight: bold;
  :hover {
    background: #c6016b;
  }
`
export const GridModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 500px;
  margin-top: 20px;
  align-items: center;
`
export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ModalHeader = styled.div`
  width: 100%;
  height: 8%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const ModalBody = styled.div`
  width: 90%;
  height: 90%;
  display: flex;
  align-self: center;
  flex-direction: column;
  justify-content: flex-start;
`
export const RowStart = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  align-self: center;
  flex-direction: row;
  justify-content: flex-start;
`
export const RowEnd = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  align-self: center;
  flex-direction: row;
  justify-content: flex-end;
`
